import React from 'react';
import PropTypes from 'prop-types';

// Set up the context
export const AnalyticsContext = React.createContext({});

/**
 * Dispatch an event to GA
 * https://developers.google.com/analytics/devguides/collection/gtagjs/events
 * @param {string} action
 * @param {string} category
 * @param {string} label
 * @param {string|number} value
 */
const sendAnalyticEvent = ({
  action,
  category,
  label,
  value = null,
}) => {
  if (window?.gtag && typeof window?.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};

const AnalyticsProvider = ({ children }) => (
  <AnalyticsContext.Provider value={{ emitEvent: sendAnalyticEvent }}>
    {children}
  </AnalyticsContext.Provider>
);

AnalyticsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AnalyticsProvider;
